// ---------------------------------------------------------------------------
// LevelUpCRM - API configuration
// ---------------------------------------------------------------------------
// ต่อกับ PaymentBroker-Backend (ชุด endpoint เดิม ไม่แก้ Backend)
//   - auth / profile / payment QR / orders  -> API จริง
//   - โมดูล CRM ที่เหลือทั้งหมด             -> mock (localStorage)
// รายการที่ต้องเพิ่มฝั่ง Backend/DB อยู่ใน comming_soon.md
// ---------------------------------------------------------------------------

export const API_BASE_URL = process.env.REACT_APP_API_URL || "https://api.swiftgoldpay.com/api/";

// โมดูล CRM ยังเป็น mock ทั้งหมด ตั้ง false ทีละตัวเมื่อ Backend พร้อม
export const USE_MOCK = {
  crm: process.env.REACT_APP_USE_MOCK_CRM !== "false",
  booking: process.env.REACT_APP_USE_MOCK_BOOKING !== "false",
  inventory: process.env.REACT_APP_USE_MOCK_INVENTORY !== "false",
  finance: process.env.REACT_APP_USE_MOCK_FINANCE !== "false",
  omnichannel: process.env.REACT_APP_USE_MOCK_OMNICHANNEL !== "false",
  org: process.env.REACT_APP_USE_MOCK_ORG !== "false",
};

export const MOCK_LATENCY = 160;

// key ใน localStorage (ใช้ชุดเดียวกับระบบอื่นในเครือ)
export const TOKEN_KEY = "scp-acc-tk";
export const PROFILE_KEY = "scp-profile";
export const MOCK_PREFIX = "levelup";

// ผู้ใช้ 2 ประเภทตามที่ตกลงกับฝั่ง Backend
export const USER_TYPE = {
  admin: "admin_crm",
  customer: "customer",
  // ทีมงานเจ้าของระบบ — ใช้บัญชี super_user ของ PaymentBroker (ยืนยันกับ Backend ทุกครั้ง ไม่ใช้ชีต users)
  superUser: "super_user",
};

// process_type ที่ส่งไปกับ order เพื่อแยกรายการของระบบนี้ออกจากระบบอื่น
export const PROCESS_TYPE = "levelup_crm";

// order_type แยกตาม flow ที่มีการจ่ายเงิน (ทุกตัวใช้ QR ตัวเดียวกัน)
export const ORDER_TYPE = {
  invoice: "crm_invoice",
  bookingDeposit: "crm_booking_deposit",
  checkout: "crm_checkout",
  paymentLink: "crm_payment_link",
  posSale: "crm_pos_sale",
  walletTopup: "crm_wallet_topup",
  installment: "crm_installment",
  subscription: "crm_subscription",
  boostTopup: "crm_boost_topup", // เติม point ปั้มไลค์/ฟอลโลว์
  addon: "crm_addon", // ฟีเจอร์เสริม / เพิ่มโควตา
  cart: "crm_cart", // ตะกร้า: หลายรายการจ่าย QR ครั้งเดียว
};

// ข้อมูล partner สำหรับเรียก transactions/deposits/partner
export const PARTNER = {
  clientId: process.env.REACT_APP_CLIENT_ID || "",
  clientSecret: process.env.REACT_APP_CLIENT_SECRET || "",
  clientRefId: process.env.REACT_APP_CLIENT_REF_ID || "",
  apigwApiId: process.env.REACT_APP_X_APIGW_API_ID || "",
  customerIdDefault: process.env.REACT_APP_CUSTOMER_ID_DEFAULT || "",
  currency: "THB",
};

export const CAPTCHA = {
  siteKey: process.env.REACT_APP_CLOUDFLARE_SITE_KEY || "",
  masterToken: process.env.REACT_APP_CAPTCHA_TOKEN_MASTER || "",
};

// อายุ QR (วินาที) ใช้เมื่อ Backend ไม่ส่ง expire_datetime กลับมา
export const QR_EXPIRE_SECONDS = 600;
export const QR_POLL_MS = 5000;
export const QR_INQUIRY_MS = 20000;

export const ENDPOINTS = {
  // auth (public)
  login: "v1/public/market/login",
  logout: "v1/public/market/logout",
  register: "v1/public/market/customer",
  resetPassword: "v1/public/reset-password",
  updateCustomer: (uid) => `v1/public/market/customer/${uid}`,
  customerAddress: "v1/public/market/customer-address",

  // profile
  profile: "v1/market/profile",
  updateUser: (uid) => `v1/admin/users/${uid}`,

  // orders
  orders: "v1/market/orders",
  orderCounts: "v1/market/orders/counts",
  orderDeliveryByTransaction: (transactionId) => `v1/market/orders/delivery/transaction/${transactionId}`,

  // payment
  depositPartner: "transactions/deposits/partner",
  depositGetById: "transactions/deposits/public/get-by-id",
  inquiry: "transactions/inquiry",
};
